export const CATALOG_TYPES = {
  GENERAL: 'CatalogTemplate',
  FORM: 'CatalogForm',
  QUIZ: 'CatalogQuiz',
  GAME: 'CatalogGame',
};
